module.exports = __webpack_public_path__ + "img/products-7.2da70698.jpg";